<template>
	<div class="card-body pt-0">
		<form-radio
			class-name="mb-0"
			:show-label="false"
			:show-all="false"
			:field="filterFields.condition"
			:count-total="countTotal"
			:ref-data="refData"
			@updateFilter="updateFilter"
		/>
		<!-- habamedia In new stores dd-datteln/dd-castrop sometimes usageType is not set-->
		<form-radio
			v-if="filterFields.usageType"
			class-name="mb-2"
			:show-label="false"
			:show-all="false"
			:field="filterFields.usageType"
			:count-total="countTotal"
			:ref-data="refData"
			@updateFilter="updateFilter"
		/>
	</div>
	<list-filter-price @updateFilter="updateFilter" />
	<div class="card-body border-top">
		<form-select
			label="Marke / Modell"
			placeholder="- Alle -"
			class-name="mb-2"
			:field="filterFields.make"
			:count-total="countTotal"
			:ref-data="refData"
			:show-zero="true"
			:disable-zero="false"
			@updateFilter="updateFilter"
		>
		</form-select>
		<form-select-model
			v-if="checkMake"
			placeholder="- Alle Modelle -"
			:field="filterFields.model"
			:loading="filterLoading"
			:count-total="countTotal"
			:ref-data="refData"
			:show-zero="false"
			@updateFilter="updateFilter"
		>
		</form-select-model>
		<div v-else class="form-group">
			<select class="form-select" aria-label="Zuerst Marke wählen" disabled>
				<option selected>- Zuerst Marke wählen -</option>
			</select>
		</div>
		<form-select
			placeholder="- Alle -"
			label="Karosserieform"
			:field="filterFields.category"
			:ref-data="refData"
			:disable-zero="true"
			:show-zero="true"
			@updateFilter="updateFilter"
		>
		</form-select>
		<form-check-delivery class="mb-2" @updateFilter="updateFilter" />
	</div>
	<div class="card-body border-top">
		<h4>Motorisierung</h4>
		<form-select
			placeholder="- Alle -"
			label="Kraftstoffart"
			:field="filterFields.fuel"
			:count-total="countTotal"
			:ref-data="refData"
			@updateFilter="updateFilter"
		/>
		<form-check
			v-if="filterFields.hybridPlugin"
			:field="filterFields.hybridPlugin"
			:ref-data="refData"
			class-name="mb-3"
			@updateFilter="updateFilter"
		/>
		<form-select-range
			label="Leistung"
			range-mode="power"
			@updateFilter="updateFilter"
		>
		</form-select-range>
		<form-select
			placeholder="- Alle -"
			label="Getriebeart"
			class-name="mt-2"
			:field="filterFields.gearbox"
			:count-total="countTotal"
			:ref-data="refData"
			@updateFilter="updateFilter"
		/>
		<form-select-range
			label="Kilometerstand"
			range-mode="milage"
			@updateFilter="updateFilter"
		>
		</form-select-range>
	</div>
	<div class="card-body border-top">
		<form-radio-color
			label="Farbe"
			class="mb-2"
			:field="filterFields.exteriorColor"
			@updateFilter="updateFilter"
		>
		</form-radio-color>
		<!-- habamedia bug with dd-datteln dd-castrop -->
		<form-check
			v-if="filterFields.metallic"
			:field="filterFields.metallic"
			:ref-data="refData"
			@updateFilter="updateFilter"
		></form-check>
	</div>
	<div class="card-body border-top">
		<form-select-store
			label="Filiale"
			:ref-data="refData"
			@updateFilter="updateFilter"
		/>
	</div>
	<div class="card-body border-top p-0">
		<div class="accordion accordion-flush" id="accordion-ausstattung">
			<div class="accordion-item">
				<h5 class="accordion-header" id="features-collapse-ausstattung-heading">
					<button
						class="accordion-button"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#features-collapse-ausstattung"
						aria-expanded="false"
						aria-controls="features-collapse-ausstattung"
					>
						Ausstattung
					</button>
				</h5>
				<div
					id="features-collapse-ausstattung"
					class="accordion-collapse collapse show"
					aria-labelledby="features-collapse-ausstattung-heading"
				>
					<div class="accordion-body">
						<form-select
							placeholder="- Alle -"
							label="Klimaanlage"
							:field="filterFields.climatisation"
							:ref-data="refData"
							@updateFilter="updateFilter"
						>
						</form-select>
						<form-check
							:field="filterFields.bluetooth"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.handsFreePhoneSystem"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.usb"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.carplay"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.androidAuto"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.wirelessCharging"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.multifunctionalWheel"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.navigationSystem"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.electricWindows"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.automaticRainSensor"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.electricHeatedSeats"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.keylessEntry"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.centralLocking"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.isofix"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<hr />
						<form-check
							:field="filterFields.fourWheelDrive"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.panoramicGlassRoof"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.sunroof"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.alloyWheels"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-radio
							label="Tempomat"
							class-name="mb-2"
							:show-label="true"
							:show-all="false"
							:field="filterFields.speedControl"
							:count-total="countTotal"
							:ref-data="refData"
							@updateFilter="updateFilter"
						/>
						<form-select
							v-if="filterFields.trailerCouplingType"
							placeholder="- Alle -"
							label="Anhängerkupplung"
							:field="filterFields.trailerCouplingType"
							:ref-data="refData"
							@updateFilter="updateFilter"
						>
						</form-select>
					</div>
				</div>
			</div>
			<div class="accordion-item">
				<h5 class="accordion-header" id="features-collapse-sicherheit-heading">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#features-collapse-sicherheit"
						aria-expanded="false"
						aria-controls="features-collapse-sicherheit"
					>
						Sicherheit
					</button>
				</h5>
				<div
					id="features-collapse-sicherheit"
					class="accordion-collapse collapse"
					aria-labelledby="features-collapse-sicherheit-heading"
					data-bs-parent="#accordion-ausstattung"
				>
					<div class="accordion-body">
						<form-radio
							label="Tagfahrlicht"
							class-name="mb-2"
							:show-label="true"
							:show-all="false"
							:field="filterFields.daytimeRunningLamps"
							:count-total="countTotal"
							:ref-data="refData"
							@updateFilter="updateFilter"
						/>
						<hr />
						<form-check
							:field="filterFields.trafficSignRecognition"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.laneDepartureWarning"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.collisionAvoidance"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
						<form-check
							:field="filterFields.blindSpotMonitor"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
					</div>
				</div>
			</div>
			<div class="accordion-item">
				<h5 class="accordion-header" id="features-collapse-polsterung-heading">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#features-collapse-polsterung"
						aria-expanded="false"
						aria-controls="features-collapse-polsterung"
					>
						Polsterung
					</button>
				</h5>
				<div
					id="features-collapse-polsterung"
					class="accordion-collapse collapse"
					aria-labelledby="features-collapse-polsterung-heading"
				>
					<div class="accordion-body">
						<form-select
							placeholder="- Alle -"
							label="Polsterart"
							:field="filterFields.interiorType"
							:ref-data="refData"
							@updateFilter="updateFilter"
						>
						</form-select>
						<form-select
							placeholder="- Alle -"
							label="Polsterfarbe"
							:field="filterFields.interiorColor"
							:ref-data="refData"
							@updateFilter="updateFilter"
						>
						</form-select>
						<form-check
							:field="filterFields.leatherSteeringWheel"
							:ref-data="refData"
							@updateFilter="updateFilter"
						></form-check>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FormSelectStore from '@/components/ui/form/FormSelectFilterStore'
import FormSelect from '@/components/ui/form/FormSelectFilter'
import FormRadio from '@/components/ui/form/FormRadioFilter'
import FormSelectRange from '@/components/ui/form/FormSelectRangeFilter'
import FormSelectModel from '@/components/ui/form/FormSelectModelFilter'
import FormRadioColor from '@/components/ui/form/FormRadioColorFilter'
import FormCheck from '@/components/ui/form/FormCheckFilter'
import FormCheckDelivery from '@/components/ui/form/FormCheckDeliveryFilter'
import store from '@/store'
import ListFilterPrice from '@/components/list/ListFilterPrice'

export default {
	name: 'ListFilter',
	components: {
		ListFilterPrice,
		FormSelectRange,
		FormSelectModel,
		FormSelectStore,
		FormSelect,
		FormRadioColor,
		FormRadio,
		FormCheck,
		FormCheckDelivery,
	},
	emits: ['updateFilter'],
	data() {
		return {
			loading: true,
			makeSelected: false,
		}
	},
	props: {
		filterFields: Object,
		filterLoading: Boolean,
		countTotal: {
			type: Number,
			default: 0,
		},
		refData: Object,
	},
	computed: {
		checkMake() {
			return store.state.filterItems['make'] !== undefined
		},
	},
	methods: {
		updateFilter() {
			this.$emit('updateFilter')
		},
	},
}
</script>
